import { render, staticRenderFns } from "./DemoSwitchTrueAndFalseValue.vue?vue&type=template&id=43253b03&"
import script from "./DemoSwitchTrueAndFalseValue.vue?vue&type=script&lang=js&"
export * from "./DemoSwitchTrueAndFalseValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
